import React from 'react'
import { useInView } from 'react-intersection-observer'

import Slider from '../slider'
import Image from '../image'
import { useSelector } from 'react-redux'

import pillShape from '../../icons/pill2-shape.svg'
import hexagonShape from '../../icons/hexagon-shape.svg'

import trads from '../../intl/trads.json'

const Challenges = ({challenges}) => {
  const lang = useSelector(state => state.lang)
  const { ref, inView} = useInView({ threshold: 0.6, triggerOnce: true})

  return (
    <div className={`challenges ${inView ? 'has-anim' : ''}`} ref={ref}>
      <h2 className="challenges__title full-width-left">
        {trads[lang].offers.titleOne} <br/> {trads[lang].offers.titleTwo}
      </h2>
      <div className="slider-cards">
        <Slider
          hasCards="true"
          nbItems={challenges.length}
          options = '{ "slidesPerView": 1, "spaceBetween": 24,"breakpoints": { "768": { "slidesPerView": 2, "spaceBetween": 24 }, "1024": { "slidesPerView": 2, "spaceBetween": 32 }} }'
          name="challenges">
          { challenges.map((challenge, i) => { 
            let color = ''
            let secondColor = ''
            let shape = (i + 1) % 2 ? 'hexagon-rotate' : 'pill'

            challenge = challenge.fields ? challenge.fields : challenge

            switch((i + 1) % 3) {
              case 1:
                color = 'turquoise'
                secondColor = 'aqua'
                break
              case 2:
                color = 'purple'
                secondColor = 'parma'
                break
              case 0:
                color = 'sienne'
                secondColor = 'beige'
                break
              default:
                color = 'purple'
                secondColor= 'parma'
            }

            return(
              <div key={(i)} className={`scroll-anim-el scroll-anim-el--${i + 1}`}>
                <div className="relative challenges__wrap">
                  <span className={`challenges__number bg-${color} center`}>{i + 1}</span>

                  { challenge.picture
                    ? <Image
                        width={ (i + 1) % 2 ? 158 : 147}
                        height={ (i + 1) % 2 ? 163 : 188}
                        classes={`shaped-image shaped-image--${shape}`}
                        sizes={{"1023": [(i + 1) % 2 ? 125 : 130, (i + 1) % 2 ? 128 : 166] }}
                        image={challenge.picture} />
                    : (i + 1) % 2 
                      ? <svg width="160px" height="160px" className={`icon-hexagon icon-${secondColor}`}>
                          <use xlinkHref={hexagonShape.url} />
                        </svg>
                      : <svg width="147px" height="188px" className={`icon-pill icon-${secondColor}`}>
                          <use xlinkHref={pillShape.url} />
                        </svg>
                  }

                  
                </div>
                <div className="challenges__content">
                  <p className={`challenges__item-title mb-2 text-${color}`}>{challenge.title}</p>
                  <p className="paragraph-big">{challenge.text.text ? challenge.text.text : challenge.text}</p>
                </div>
              </div>
            )
          }) }
        </Slider>
      </div>
    </div>
  )
}

export default Challenges